<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="80%"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
          :rules="rules"
          :disabled="disabled"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="盘点单号" prop="Code">
                <el-input v-model="form.Code" placeholder="盘点单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="盘点时间" prop="CheckTime">
                <el-date-picker
                  v-model="form.CheckTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 100%"
                  placeholder="请选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="备注" prop="Remarks">
                <el-input
                  type="textarea"
                  v-model="form.Remarks"
                  placeholder=""
                  rows="3"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="line-height: 30px">
          <el-button
            type="primary"
            @click="addList"
            v-if="!disabled"
            icon="el-icon-plus
"
            >获取库存</el-button
          >
        </div>
        <el-table
          :data="form.detailList"
          ref="dialogTable"
          style="width: 100%"
          height="calc(100% - 100px)"
        >
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>

          <el-table-column label="备件编号" align="center" prop="Code" sortable>
          </el-table-column>
          <el-table-column label="备件名称" align="center" prop="Name" sortable>
          </el-table-column>
          <el-table-column
            label="备件类型"
            align="center"
            prop="MaterialTypeName"
            sortable
          >
          </el-table-column>
          <el-table-column label="备件规格" align="center" prop="Spec" sortable>
          </el-table-column>
          <el-table-column
            label="单位"
            align="center"
            prop="storageName"
            sortable
          >
          </el-table-column>

          <el-table-column
            label="货位"
            align="center"
            prop="LocalName"
            sortable
          >
          </el-table-column>
          <el-table-column label="库存数量" align="center" prop="Nums" sortable>
          </el-table-column>
          <el-table-column
            label="盘点数量"
            align="center"
            prop="CheckQty"
            sortable
          >
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.CheckQty"
                type="number"
                :disabled="disabled"
                :controls="false"
                style="width: 100%"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column
            label="盘亏/盘赢数量"
            align="center"
            prop="DifferenceQty"
            sortable
            v-if="title == '盘点详情'"
          >
            <template slot-scope="scope">
              <span :style="`color: ${color(scope.row.DifferenceQty)}`">{{
                scope.row.DifferenceQty
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit" v-if="!disabled"
          >保存</el-button
        >
        <el-button
          @click="handleAudit"
          type="success"
          v-if="title == '确认盘点'"
        >
          确认盘点</el-button
        >
      </div>
    </el-drawer>
    <!-- <Supplier ref="Supplier" type="radio" @select="selectSup"></Supplier>
    <FittingsOut ref="FittingsOut" @select="selectFittingsOut"></FittingsOut> -->
  </div>
</template>
<script>
import Supplier from '@/components/Supplier/Supplier.vue'
import FittingsOut from '@/components/Fittings/FittingsOut.vue'
import SekectShelf from '@/components/SekectShelf/SekectShelf.vue'
import Token from '@/utils/cache/TokenCache.js'
import moment from 'moment'
export default {
  data() {
    return {
      title: '',
      loading: false,
      token: 'Bearer ' + Token.getToken(),
      RoleList: [],
      tD_OutStorDetails: [],
      form: {
        Code: '',
        CheckTime: '',
        Remarks: '',
        detailList: [],
      },
      rules: {
        CheckTime: [
          { required: true, message: '请选择日期', trigger: 'change' },
        ],
        Code: [{ required: true, message: '请输入盘点单号', trigger: 'blur' }],
      },
      drawer: false,
      disabled: false,
      flag: false,
      row: {},
    }
  },
  props: {},
  components: { Supplier, FittingsOut, SekectShelf },
  methods: {
    color(num) {
      if (num > 0) {
        return '#409EFF'
      } else if (num == 0) {
        return ''
      } else {
        return 'red'
      }
    },
    handleAudit() {
      this.$confirm('是否确认开始盘点？', {
        type: 'warning',
      }).then(() => {
        this.loading = true
        this.$http
          .post('/TD/TD_CheckMain/ConfirmData', { id: this.row.Id })
          .then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    PriceChange(price, row) {
      if (Number(price) < 0) {
        this.$notify.error('价格不能为负数')
        this.$set(row, 'Price', 0)
      } else if (!/^\d+(\.\d{1,4})?$/.test(price)) {
        this.$notify.error('价格最多只能保留四位小数')
        const validPrice = parseFloat(price).toFixed(4)
        this.$set(row, 'Price', validPrice)
      }
      const formattedTotalAmt = ((row.Num || 0) * (row.Price || 0)).toFixed(4)
      Number(formattedTotalAmt).toLocaleString('en-US', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      })
      this.$set(row, 'TotalAmt', formattedTotalAmt)
    },
    NumChange(num, row) {
      console.log(num, row)
      if (!Number.isInteger(Number(num))) {
        this.$notify.error('数量不能为小数或负数')
        this.$set(row, 'OutNum', Math.floor(Number(num)))
      } else if (Number(num) < 0) {
        this.$notify.error('数量不能为小数或负数')
        this.$set(row, 'OutNum', 0)
      } else if (Number(num) > Number(row.Nums_N)) {
        this.$notify.error('数量不能超过库存数量')
        this.$set(row, 'OutNum', row.Nums_N)
      }

      // const formattedTotalAmt = ((row.Num || 0) * (row.Price || 0)).toFixed(4);
      // const formattedTotalAmtWithCommas = Number(formattedTotalAmt).toLocaleString(
      //   "en-US",
      //   {
      //     minimumFractionDigits: 4,
      //     maximumFractionDigits: 4,
      //   }
      // );
      // this.$set(row, "TotalAmt", formattedTotalAmtWithCommas);
    },
    selectShelf(obj, row) {
      console.log(obj, row)
      this.$set(row, 'LocalName', obj.Name)
      this.$set(row, 'AreaId', obj.PB_StorArea.Id)
      this.$set(row, 'RackId', obj.PB_Rack.Id)
    },
    selectFittingsOut(arr) {
      console.log(arr)
      if (this.tD_OutStorDetails.length == 0) {
        arr.forEach((item) => {
          this.tD_OutStorDetails.push({
            ...item,

            OutNum: '',
            // MaterialId: item.Id,
            // AreaId: "",
            // RackId: "",
            // LocalName: "",
            // LocalId: "",
            // Price: "",
            // TotalAmt: "",
          })
        })
      } else {
        const duplicateIds = []
        arr.forEach((item) => {
          const exists = this.tD_OutStorDetails.some(
            (detail) => detail.MaterialId === item.Id
          )
          if (exists) {
            duplicateIds.push(item.Name)
          } else {
            this.tD_OutStorDetails.push({
              ...item,
              OutNum: '',
            })
          }
        })
        if (duplicateIds.length > 0) {
          this.$notify.warning(
            `以下备件已存在，未重复添加: ${duplicateIds.join(', ')}`
          )
        }
      }
    },
    addList() {
      this.loading = true
      this.$http
        .post('/IT/IT_LocalMaterial/GetLocalMaterialList', {})
        .then((res) => {
          this.loading = false
          if (res.Success) {
            res.Data &&
              res.Data.forEach((item) => {
                this.$set(item, 'Nums', item.Nums_N)
              })
            this.form.detailList = [...res.Data]
          } else {
            this.form.detailList = []
            this.$notify.error(res.Msg)
          }
        })
      // this.$refs.FittingsOut.openDialog();
    },
    selectSup(arr) {
      console.log(arr)
      this.$set(this.form, 'SupId', arr[0].Id)
      this.$set(this.form, 'SupName', arr[0].Name)
    },
    openSup() {
      this.$refs.Supplier.openDialog()
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.status == 'done') {
        this.form.HeadImg = res.url

        console.log(this.form.HeadImg)
      } else {
        this.$notify.error(res.Msg)
      }
    },
    getRoleList() {
      this.$http
        .post('/Base_Manage/Base_Role/GetDataList', {
          SortField: 'CreateTime',
          SortType: 'Desc',
        })
        .then((resJson) => {
          if (resJson.Success) {
            this.RoleList = resJson.Data
          }
        })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        if (this.form.detailList?.length <= 0) {
          return this.$notify.warning('请获取库存后保存')
        }

        this.loading = true
        this.$http
          .post('/TD/TD_CheckMain/SaveData', {
            ...this.form,
            Status: 0,
          })
          .then((resJson) => {
            this.loading = false

            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}, disabled = false, flag = false) {
      this.drawer = true
      this.disabled = disabled
      this.flag = flag

      this.row = row
      this.form = {
        Code: '',
        CheckTime: '',
        Remarks: '',
        detailList: [],
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/TD/TD_CheckMain/GetTheData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
